import {range, sortBy, values, compact, find} from 'lodash';
import getNormalRequest from './getNormalRequest';
import getAppendPreviewRequest from './getAppendPreviewRequest';

export interface GetTrackLineRequestsOptions {
    includeAppendPreviewLine?: boolean;
    interaction?: MapInteraction | undefined;
    project: MapProject;
    track: Track;
}

function getDraggingPointLocalId(interaction: MapInteraction | undefined) {
    if (!interaction) return undefined;
    else if (interaction.subtype === 'draggingPoint') return interaction.pointLocalId;
    else if (interaction.subtype === 'dragging') return interaction.pointLocalId;
}

export default function getTrackLineRequests({
    interaction,
    project,
    track,
    includeAppendPreviewLine = false,
}: GetTrackLineRequestsOptions): TrackLineRequest[]  {
    if (!track.isGeometryLoaded) return [];

    if (
        track.unmodifiedLine && (
            track.properties.track_type !== 'route' ||
            !find(track.points, point => point.properties.isGeometryModified)
        )
    ) {
        return [{
            type: 'sync',
            geometry: track.unmodifiedLine.geometry,
            properties: track.unmodifiedLine.properties,
        }];
    }

    const points = sortBy(
        values(track.points).filter(point => !point.properties.isLocallyDeleted),
        point => point.properties.order
    );

    const draggingPointLocalId = getDraggingPointLocalId(interaction);

    const lines = range(Math.max(points.length - 1, 0)).map((index: number) => {
        const fromPoint = points[index];
        const toPoint = points[index + 1];

        return getNormalRequest({
            track,
            project,
            fromPoint,
            toPoint,
            draggingPointLocalId,
        });
    });

    return compact([
        ...lines,
        includeAppendPreviewLine && getAppendPreviewRequest(track, interaction, project)
    ]);
}
